import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import DynamicSizeIcon from "../DynamicSizeIcon";
import DynamicFontSize from "../DynamicFontSize";
import { useGlobalData } from "@/contexts/GlobalData";
import { ReactNode } from "react";
import { cn } from "@/lib/utils";
export interface SettingItemPropsType extends GeneralPropsType {
  icon?: string;
  name?: string;
  des?: string;
  onClick?: (data?: any) => any;
  hideNavigationArrow?: boolean;
  overrideNameFontsize?: number;
  active?: boolean;
  value?: ReactNode;
  rightSide?: ReactNode;
  arrowClassName?: string;
  overrideArrowSrc?: string;
}
function SettingItem({
  children,
  icon,
  des,
  name,
  className,
  hideNavigationArrow,
  onClick,
  overrideNameFontsize,
  active,
  value,
  rightSide,
  arrowClassName,
  overrideArrowSrc
}: SettingItemPropsType) {
  const {
    getIcon
  } = useGlobalData();
  return <button onClick={onClick} className={clsx("flex items-center gap-2 cursor-pointer active:translate-x-2.5 duration-300 text-left w-full", styles.container, className)} data-sentry-component="SettingItem" data-sentry-source-file="index.tsx">
            <DynamicSizeIcon width={36} icon={icon} data-sentry-element="DynamicSizeIcon" data-sentry-source-file="index.tsx"></DynamicSizeIcon>
            <div className="flex flex-col flex-1">
                {name && <DynamicFontSize fontSize={overrideNameFontsize ?? 14} className="text-white font-medium">
                        {name}
                    </DynamicFontSize>}
                {des && <DynamicFontSize fontSize={13} className="text-description">
                        {des}
                    </DynamicFontSize>}
                {children}
            </div>
            {(!hideNavigationArrow || !!value) && <div className="flex ml-auto items-center gap-2">
                    {value && <DynamicFontSize fontSize={13} className="text-white leading-[150%]">
                            {value}
                        </DynamicFontSize>}
                    {!hideNavigationArrow && <DynamicSizeIcon className={clsx("", arrowClassName)} width={7} height={11} icon={overrideArrowSrc ?? getIcon("right_arrow_setting")}></DynamicSizeIcon>}
                </div>}
            {rightSide}
            {active && <DynamicSizeIcon className="ml-auto" width={20} icon={getIcon("active_setting")}></DynamicSizeIcon>}
        </button>;
}
export default SettingItem;